import useSWR from "swr";
import {
  type DocumentShareTarget,
  type SharedDocumentDetails,
  type SharedDocumentSummary,
  type SharedDocumentsOverview,
} from "~/api/types";
import { simpleFetcher } from "~/api/fetcher";

/** Documents shared to the active group by its ancestors. */
export function useSharedDocuments() {
  return useSWR<SharedDocumentSummary[], Error>(
    "/api/v2/shared-documents",
    simpleFetcher,
  );
}

/** A single shared document, for the receiving-side read-only view. */
export function useSharedDocument(documentId: number | undefined) {
  return useSWR<SharedDocumentDetails, Error>(
    documentId === undefined ? null : `/api/v2/shared-documents/${documentId}`,
    simpleFetcher,
  );
}

/** The groups a document owned by the active group is shared to. */
export function useDocumentShares(documentId: number | undefined) {
  return useSWR<DocumentShareTarget[], Error>(
    documentId === undefined ? null : `/api/v2/documents/${documentId}/shares`,
    simpleFetcher,
  );
}

/** Shared documents to and from a group, for the organisations page. */
export function useSharedDocumentsOverview(companyGroupId: number | undefined) {
  return useSWR<SharedDocumentsOverview, Error>(
    companyGroupId === undefined
      ? null
      : `/api/v2/shared-documents/overview/${companyGroupId}`,
    simpleFetcher,
  );
}
